<template>
  <div class="TopicDetailsList">
    <div class="container-fluid">
      <div class="table-responsive margin-Top-3Perc margin-left-2Point7Perc margin-right-1Point1Perc" >
          <table class="table table-striped ">
            <thead>
              <tr v-if="topicList.length !== 0">
                  <th class="text-align-center text-valign-middle font-size-15px border-right padding-left-2px">Name</th>
                  <th colspan="2" class="text-align-center text-valign-middle font-size-15px padding-left-2px">Action</th>            
              </tr>
            </thead>
            <tbody class="border-top">
              <tr v-for="topicObj in topicList" :key="topicObj.TopicId" v-bind:topicObj = "topicObj" class="" >
                  <td class="text-align-center text-valign-middle border-right col-lg-9 ">{{topicObj.TopicName}}
                  </td>
                  <td class="col-lg-3 text-align-center">
                    <a @click="openEditTopicOverlay($event,true,topicObj)" class="cursor-pointer"> Edit </a>|
                    <a @click="setShowConfirmationBoxAsTrue($event,true,topicObj)" class="cursor-pointer"> Delete </a>
                  </td>
              </tr>
            </tbody>
        </table>
      </div>
    </div>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteTopicString" v-bind:postfixString="postDeleteTopicString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteSelectedTopic"></confirmation-alert>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <edit-topic v-if="showEditTopicOverlay" v-bind:selectedTopicObj="selectedTopicObj" @refreshTopicList="refreshTopicList" @updateFlag="updateShowEditTopicOverlayFlag"></edit-topic>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>
  </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import EditTopicOverlay from '@/components/UpdateTopicOverlay'
import AlertBox from '@/components/AlertOverlay'
import { topicService } from '@/server-util/topic-service'
export default {
  props: ['topicList'],
  data: function () {
    return {
      selectedTopicObj: null,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      showConfirmationBox: false,
      prefixDeleteTopicString: 'Are you sure you want to delete ',
      postDeleteTopicString: '',
      showEditTopicOverlay: false
    }
  },
  methods: {
    refreshTopicList (value) {
      if (value) {
        // AK: For Edit topic, Re-emit Refresh Topic List call (ChallengesTopics file)
        this.$emit('refreshTopicList', true)
      }
    },
    updateShowEditTopicOverlayFlag (value) {
      // AK: Used to hide update Overlay after successful updation of topic or user close explicitly
      this.showEditTopicOverlay = value
      // AK: Enabled Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    openEditTopicOverlay: function ($event, flagToUpdate, topicObj) {
      // AK: Used when user pressed Edit to open Edit Topic overlay
      this.showEditTopicOverlay = flagToUpdate
      this.selectedTopicObj = topicObj
      // AK: Disable Background Scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    setShowConfirmationBoxAsTrue: function (event, flagToUpdate, topicObj) {
      // AK: Used when user pressed delete to open delete Topic overlay
      this.showConfirmationBox = flagToUpdate
      this.selectedTopicObj = topicObj
      this.postDeleteTopicString =
        '\'' + this.selectedTopicObj.TopicName + '\' topic?'
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateShowSpinnerFlag (value) {
      // this.showSpinner = value
      this.$store.state.isLoading = value
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete Group overlay
      this.showConfirmationBox = value
    },
    deleteSelectedTopic (value) {
      var _this = this
      var storeObj = this.$store
      // console.log(JSON.stringify(this.selectedTopicObj))
      if (value) {
        if (
          this.selectedTopicObj.TopicId !== undefined ||
          this.selectedTopicObj !== null
        ) {
          // AK: Show Spinner
          // this.showSpinner = true
          this.$store.state.isLoading = true
          // AK: Hide Delete Confirmation Box
          _this.showConfirmationBox = false
          topicService
            .deleteTopic(
              storeObj.state.access_token,
              this.selectedTopicObj.TopicId
            )
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  // AK: Refresh Topic List (ChallengesTopics file)
                  _this.$emit('refreshTopicList', true)
                  // AK: Hide Spinner
                  // _this.showSpinner = false
                  _this.$store.state.isLoading = false
                } else {
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                  // this.showSpinner = false
                  _this.$store.state.isLoading = false
                }
              },
              errorObj => {
                // AK: Hide Spinner
                // this.showSpinner = false
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              }
            )
        } else {
          console.log(
            'Selected COURSE Object is NULL hence declined DELETE COURSE OPERATION'
          )
        }
      }
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'edit-topic': EditTopicOverlay,
    'loader': Loader
  }
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.TopicDetailsList{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.text-align-center {
  text-align: center !important;
}
.text-align-left {
  text-align: left !important;
}
.text-valign-middle{
  vertical-align: middle;
}
.cursor-pointer {
  cursor: pointer;
}
.icon-width-height {
  width: 24px;
  height: 29px;
}
.align-center {
  margin: 0 auto !important;
}
.img-align-right{
  float:right;
}
.img-align-left{
  float:left;
}
.margin-right-minus3Perc{
  margin-right:-3%;
}
.border-right
{
  border-right: 1px solid #aaa !important;
}
.border-top
{
  border-top: 1px solid red !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
  .table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}

.margin-left-2Point7Perc{
    margin-left: 2.7% !important;
}
.margin-right-1Point1Perc{
    margin-right: 1.1% !important;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.cursor-pointer{
    cursor: pointer;
}
.padding-left-2px{
  padding-left:2% !important;
}
.border-red{
  border: 1px solid red;
}
/* .table th, .table td { border-top: none !important; }
.table > tbody > tr:first-child > td {
    border-top: none !important;
}
.table > tbody > tr:first-child > td {
    border: none;
} */
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}

</style>


// WEBPACK FOOTER //
// src/components/TopicDetailsList.vue